import React from "react";
import "./GradientOverlay.css";

const GradientOverlay = () => {
  return <div className="gradient-overlay" />;
};

export default GradientOverlay;
